<template>
  <v-dialog v-model="slotVisible" @click:outside="close" width="480px" class="dialog">
    <v-row no-gutters style="background-color: #21343b; justify-content: space-between" class="px-7 pt-8 pb-5">
      <span class="txt-section-title ml-2">{{ title }}</span>
      <v-btn dark elevation="0" icon @click="close">
        <v-icon color="white">mdi-close</v-icon>
      </v-btn>
    </v-row>
    <v-row class="px-6 row-dialog">
      <p class="mx-3" v-html="sub" style="color: #96a7af; margin-bottom: 0px"></p>
    </v-row>
    <v-row class="px-6 row-dialog">
      <input-email v-if="!isDone" @done="done" @close="close" :isDialog="true"></input-email>
    </v-row>
    <v-row class="px-6 pb-10 row-dialog">
      <v-btn
        class="mt-5"
        v-if="isDone"
        block
        elevation="0"
        height="40"
        width="80"
        color="primary"
        dark
        id="continue"
        @click="close"
      >
        close
      </v-btn>
    </v-row>
  </v-dialog>
</template>

<script>
import InputEmail from '@/views/workspace/component/InputEmail'
export default {
  name: 'SlotDialog',
  components: { InputEmail },
  props: {
    slotVisible: Boolean,
  },
  data() {
    return {
      title: this.$t('inviteTeammates'),
      sub: this.$t('inviteTeammatesDesc'),
      isDone: false,
      slotDialog: false,
    }
  },
  methods: {
    close() {
      this.$emit('close', 'Slot')
    },
    done() {
      this.isDone = true
      this.title = this.$t('joinWorkspaceComplete')
      this.sub = this.$t('inviteTeammatesDone')
    },
  },
}
</script>

<style scoped>
.v-dialog__content >>> .v-dialog {
  border-radius: 24px;
  overflow: hidden;
}
.txt-section-title {
  font-weight: 700;
  font-size: 18px;
  color: white;
  align-self: center;
}
.row-dialog {
  background-color: #21343b;
  margin: 0 !important;
}
</style>
